import { selectFeatureFlag } from '../../selectors/feature-flags';

export const getThrottleMqttMessages = state => selectFeatureFlag(state, 'throttle-mqtt-messages');
